/**
 * SignalR hook – no-op stub (SignalR not used in current architecture).
 *
 * Real-time is handled by SSE/polling (e.g. knowledge scrape stream).
 * This hook keeps the same API so callers do not break.
 */

import { useState, useCallback } from 'react';

const noop = async () => {};

export const useSignalR = (_userId, _onProgressUpdate, _onNotificationCountUpdate, _onKnowledgeUpdate) => {
  const [connectionState] = useState('Disconnected');
  const [isConnected] = useState(false);
  const [error] = useState(null);

  return {
    connectionState,
    isConnected,
    error,
    connect: useCallback(noop, []),
    disconnect: useCallback(noop, []),
    sendMessage: useCallback(noop, []),
  };
};

export default useSignalR;
